<!--添加库存-->
<template>
<div>
  <el-dialog :title="msg(title)" :visible.sync="visible" :fullscreen="isMinScreen" 
        :close-on-click-modal="false" 
        :lose-on-press-escape="false"
        width="70%"
    >
    <div v-if="inventory">
        <h3>{{ msg('库存信息') }}</h3>
        <el-form label-width="100px">
            <el-row type="flex" justify="start" style="flex-wrap: wrap;">
                <el-col :xs="24" :sm="8" :md="8" >
                    <el-form-item :label="msg('库存编号')" label-width="100px" >
                        <el-input v-model="inventory.code" placeholder="必填项" size="small">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8">
                    <el-form-item :label="msg('仓库')">
                        <el-select v-model="inventory.storeId"  placeholder="请选择" size="small"
                            clearable @clear="clearStore"
                        >
                            <el-option
                                v-for="item in stores"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="type==1" :xs="24" :sm="8" :md="8" >
                    <el-form-item :label="msg('架位号')" label-width="100px">
                        <el-input v-model="inventory.shelfCode" placeholder="必填项" size="small">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <!-- <el-col :xs="24" :sm="12" :md="8" >
                    <el-form-item :label="msg('货物类型')">
                        <el-select v-model="inventory.productType"
                            placeholder="选择货物类型" size="small">
                            <el-option
                                v-for="item in this.dicts.stockExpGoodType"
                                :key="item.value" 
                                :label="item.label"
                                :value="item.value"> 
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" >
                    <el-form-item :label="msg('仓储类型')">
                        <el-select v-model="inventory.storeType"
                            placeholder="选择货物类型" size="small">
                            <el-option
                                v-for="item in this.dicts.inventoryStoreTypes"
                                :key="item.value" 
                                :label="item.label"
                                :value="item.value"> 
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col> -->
                <el-col :xs="24" :sm="8" :md="8" >
                    <el-form-item :label="msg('归属人')" >
                        <el-autocomplete size="small"
                            v-model="inventory.ownerName"
                            :fetch-suggestions="searchUser"
                            :placeholder="this.msg('搜索归属人')"
                            :trigger-on-focus="false"
                            @select="selectUser"
                            @clear="clearUsername"
                        ></el-autocomplete>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8">
                    <el-form-item :label="msg('备注')">
                        <el-input v-model.trim="inventory.remark1" :placeholder="msg('请输入备注')" size="small"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8" >
                    <el-form-item :label="msg('说明')">
                        <el-input v-model.trim="inventory.remark2" :placeholder="msg('请输入说明')" size="small"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
            </el-row>
            <el-row>
                <el-col :xs="24" :sm="8" :md="8" >
                    <el-form-item :label="msg('件数')">
                        <el-input-number v-model="inventory.qty" :min="0" size="mini"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8" >
                    <el-form-item :label="msg('总成本')">
                        <el-input-number v-model="inventory.totalCost" :min="0" size="mini" @change="changeTotalCost"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8" >
                    <el-form-item :label="msg('单件成本')">
                        <el-input-number v-model="inventory.cost" :min="0" size="mini"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24" :sm="8" :md="10" >
                    <el-form-item :label="msg('SKU')">
                        <el-input v-model.trim="inventory.sku" :placeholder="msg('请输入SKU')" maxlength="64" show-word-limit size="small"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="10" >
                    <el-form-item :label="msg('货号')">
                        <el-input v-model.trim="inventory.variationSku" :placeholder="msg('请输入货号')" maxlength="64" show-word-limit size="small"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24" :sm="8" :md="10" >
                    <el-form-item :label="msg('规格')">
                        <el-input v-model.trim="inventory.spec" :placeholder="msg('请输入规格')" maxlength="100" show-word-limit size="small"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="10" >
                    <el-form-item :label="msg('产品名')">
                        <el-input v-model.trim="inventory.title" :placeholder="msg('请输入产品名')" maxlength="100" show-word-limit size="small"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div style="text-align:center; margin-top: 15px;">
            <el-button size="mini"  @click="close(false)"><i class="el-icon-close"></i><span>{{msg('取消')}}</span></el-button>
            <el-button type="primary" size="mini"  @click="onSubmit()"><i class="el-icon-check"></i><span>{{btnText}}</span></el-button>
        </div>
    </div>

    <el-dialog :title="msg('仓储类型选择')" :visible.sync="storeTypevisible" 
        :fullscreen="isMinScreen" 
        :close-on-click-modal="false" 
        append-to-body
        min-width="300px"
    >
        <el-row class="wrap-panel">
            <el-tag type="danger">检测到该仓库可存放多种仓储类型的货物，请选择您要存入库存所属的仓储类型：</el-tag>
            <div style="margin-top:10px;">
                <el-select v-model="storeType"  placeholder="请选择仓储类型" size="mini" clearable >
                    <el-option
                        v-for="item in checkStoreTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div style="text-align:left; margin-top:20px;">
                <el-button type="primary" size="mini"  @click="doSubmit"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
                <el-button  size="mini" v-on:click="storeTypevisible=false">{{msg('取消')}}</el-button>
            </div>
        </el-row> 
    </el-dialog>

</el-dialog>
</div>
</template>
<script>

export default {
    name: "InventoryStoreType",
    components: {
    },
    mounted: function(){

    },
    data() {
        return {
            visible: false,
            inventory: null,
            stores: null,
            title: null,
            btnText: null,
            type:null,
            storeTypevisible:false,
            storeType:null,
            checkStoreTypes:[],
            single: 1,  //是否允许存在多单号1-不允许
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
    },
    methods: {
        searchUser(queryString, cbFn){  //搜索用户
            this.$axios.get(this.$kit.api.user.search
                +"?name="+encodeURIComponent(queryString)+"&type=1")
            .then((result) => {
                if(result.status){
                    let users =[];
                    result.data.forEach(e => {
                        users.push({
                            id: e.id,
                            value: e.value
                        });
                    });
                    cbFn(users);
                }
            });
        },
        //type: 1=新增，0-预报
        showAdd(type, inv){
            this.type = type;
            this.title = type==1?"新增库存":"预报库存";
            this.btnText = type==1?"确认新增":"确认预报";
            if(type == 1 && !this.hasPermission('stock:batchFieldStore')){
                this.getOwnStores();
            }else{
                this.getStores();
            }

            if(!inv){
                inv = {
                    id: null,
                    code: null,
                    storeName: null,
                    storeId: null,
                    shelfCode: null,
                    prodcutType: 0,
                    origin: null,
                    remark1: null,
                    remark2: null,
                    subCode: null,
                    title: null,
                    spec:null,
                    qty: 1,
                    totalCost:0,
                    cost: 0,
                    sku: null,
                    variationSku: null,
                    storeType: null,
                }
                this.single = 1;
            }else{
                this.single = 0;
            }

            let code = null;
            if(type == 1){
                if(inv && inv.status != 5){
                    code = inv.code;
                }
            }else {
                if(inv && inv.status == 5){
                    code = inv.code;
                }
            }

            this.inventory = {
                id: null,
                code: code,
                storeName: inv.storeName,
                storeId: inv.storeId,
                shelfCode: type==1?inv.shelfCode:null,
                prodcutType: inv.prodcutType,
                origin: inv.origin,
                remark1: inv.remark1,
                remark2: inv.remark2,
                subCode: null,
                title: inv.title,
                spec:inv.spec,
                qty: 1,
                totalCost:inv.totalCost,
                cost: inv.cost,
                sku: inv.sku,
                variationSku: inv.variationSku,
                storeType: inv.variationSku
            };
            this.visible = true;
        }, 
        showEdit(inv){
            this.title = "编辑库存";
            this.btnText = "确认更新";
            this.getStores();
            this.inventory = {...inv};
            this.inventory.cost = ((this.inventory.cost || 0) / 100).toFixed(2);
            this.visible = true;
        },
        selectUser(item) { //获取选中的用户
            this.inventory.ownerId = item.id;
            this.inventory.ownerName = item.value;
        },
        clearUsername(){
            this.inventory.owner = null;
            this.inventory.ownerName = null;
        },
        getStores(){
            this.$axios.post(this.$kit.api.store.listUsed)
                .then((result)=> {
                    if(result.status){
                        this.stores = result.data;
                    }
                });
        },
        getOwnStores(){
            this.$axios.post(this.$kit.api.store.listByOwn)
                .then((result)=> {
                    if(result.status){
                        this.stores = result.data;
                    }
                });
        },
        changeTotalCost(){
            let totalCost = this.inventory.totalCost?this.inventory.totalCost:0;
            let qty = this.inventory.qty?this.inventory.qty:0;
            this.inventory.cost = (totalCost / qty).toFixed(2);
        },
        clearStore(){
            this.inventory.storeId = null;
        },
        close(refresh){
            this.visible = false;
            this.$emit("finish", refresh);
        },
        onSubmit(){
            
            if(this.type == 1){//新增
                if(!this.inventory.storeId || !this.inventory.shelfCode){
                    this.$message("新增，仓库和架位号为必填项");
                    return;
                }
            }else{
                if(!this.inventory.storeId || !this.inventory.code){
                    this.$message("预报，库存单号和仓库为必填项");
                    return;
                }
            }

            //检测所选仓库的仓储类型是否是多个，如果是则需要弹窗选择一个仓储类型
            this.$axios.get(this.$kit.api.store.checkStore+"?store="+this.inventory.storeId)
            .then((result) => {
                if(result.status){
                    this.checkStoreTypes = [];
                    this.storeTypevisible = true;
                    this.storeType = null;
                    // this.checkStoreTypes = result.data; 
                    let data = result.data; 
                    let types = data.split(',');
                    types.forEach(e => {
                        let storeType = this.dicts.inventoryStoreTypes.find(d => d.value === +e);
                        this.checkStoreTypes.push(storeType);
                    })
                }else{
                    this.doSaveOrUpdate();
                }
            });

        },
        doSubmit(){
            if(!this.storeType){
                this.$message("请选择库存类型");
                return;
            }
            this.doSaveOrUpdate(this.storeType);
        },
        doSaveOrUpdate(storeType){

            this.inventory.storeType = storeType;
            let inv = {...this.inventory};
            
            inv.cost = ((inv.cost || 0) * 100).toFixed(); 

            let url = inv.id? this.$kit.api.inventory.update : this.$kit.api.inventory.add;

            this.$axios.post(url+"?type="+this.type+"&s="+this.single, inv)
            .then((result) => {
                this.$message(result.msg);
                if(result.status){
                    this.storeTypevisible =  false;
                    this.close(true);
                }
            });
        }
    }
}
</script>